import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import notificationReducer from "./notification/notificationReducer";
import tableReducer from "./table/tableReducer";
import formReducer from "./form/formReducer";
import { NotifType } from "./notification/notificationActions";
import userReducer from "./user/userReducer";
import mapReducer from "./map/mapReducer";

const persistConfig = {
  key: "root",
  storage,
  whiteList: ["user"],
  blacklist: ["table", "form", "notification"],
};

interface IRootState {
  notification: {
    open: boolean;
    message: string;
    type: NotifType;
  };
  table: {
    filters: any;
    data: any;
    filterTags: any;
  };
  form: {
    hasValue: boolean;
  };
  user: {
    user: any;
  };
}

const rootReducer = combineReducers({
  user: userReducer,
  notification: notificationReducer,
  table: tableReducer,
  form: formReducer,
  mapInfo: mapReducer,
});

export default persistReducer(persistConfig, rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
